import { render, staticRenderFns } from "./PrivacyStatementViewHU.vue?vue&type=template&id=24b8e196&scoped=true"
import script from "./PrivacyStatementViewHU.vue?vue&type=script&lang=js"
export * from "./PrivacyStatementViewHU.vue?vue&type=script&lang=js"
import style0 from "./PrivacyStatementViewHU.vue?vue&type=style&index=0&id=24b8e196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b8e196",
  null
  
)

export default component.exports